var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"id":"header"}},[_c('div',{staticClass:"header-l",attrs:{"id":"reloadContent"},on:{"click":_vm.reloadContent,"mouseover":_vm.showSidebarMenu,"mouseleave":_vm.hideSidebarMenu}},[_c('router-link',{staticClass:"header-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/web/images/logo-01.svg","alt":"logo"}})])],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f01ca2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/HeaderBar.vue
// module id = nnrP
// module chunks = 3 4